import React, { useState } from "react";
import { Layout } from "antd";
import {
  CREATOR_LINK,
  CREATOR_NAME,
  PROJECT_NAME,
} from "../../constants/constent";
import LS_SERVICE from "../../utils/localStorage";
import { Link } from "react-router-dom";

function LayoutFooter() {
  const { Footer } = Layout;
  const [companyName] = useState(PROJECT_NAME);
  const handleOpenLink = () => {
    window.open(CREATOR_LINK, "_blank", "noopener,noreferrer");
  };

  return (
    <Footer
      style={{
        textAlign: "center",
      }}
    >
      {LS_SERVICE.get("setting")
        ? LS_SERVICE.get("setting")["company_name"] + " "
        : companyName + " "}
      ©{new Date().getFullYear()} Created by{" "}
      <Link onClick={handleOpenLink} to="#">
        {CREATOR_NAME}
      </Link>
    </Footer>
  );
}

export default LayoutFooter;
